module.exports = {

  apply: "Apply Filter",
  update: "Apply Filter",
  clear: "Reset Filter",

  operators: {
    ">" : ">",
    ">=" : ">=",
    "<" : "<",
    "<=" : "<=",
    "=" : "=",
    "Regex" : "regex",
    "!regex" : "not regex",
    "include" : "include",
    "exclude" : "exclude"
  },

  andLine: "and",
  orLine: "or",

  and: "and",
  or: "or",

  summary:{
    activeFilter: "Active filter:",
    filter: "Filter:"
  }
}


// WEBPACK FOOTER //
// ../i18n/en/filter.js